import { render, staticRenderFns } from "./index.vue?vue&type=template&id=302546ec&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=302546ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "302546ec",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseLayoutPageHeader: require('/opt/cargo.front/src/components/base/layout/page-header.vue').default,RzIconDropArrow: require('/opt/cargo.front/node_modules/@razlet/ui/lib/modules/icons/icon-drop-arrow/index.js').default,RzContainer: require('/opt/cargo.front/node_modules/@razlet/ui/lib/modules/components/container/index.js').default})
